import request from './ajax'

const newsUrl = '/api/shop_order/'
// 获取线下支付订单列表
export const getShopOrderList = (data) => request(newsUrl + 'order', 'post', { ...data })
